import React from "react";
import {
  ContentLayout,
  Box,
  Link,
  SpaceBetween,
} from "@amzn/awsui-components-react/polaris";
import { ACCESS_REQUEST_URL, ACCESS_REQUEST_URL_CANADA } from "../../app/constants";
const Error403 = () => {
  return (
    <div className="centered">
      <ContentLayout>
        <Box variant="h1" textAlign="center">
          403 Error
        </Box>
        <Box variant="h2" textAlign="center">
          Forbidden
        </Box>
        <SpaceBetween direction="vertical" size="xs">
          <Box variant="p" textAlign="center">
            You do not have permissions to access this application.
          </Box>
          <Box variant="p" textAlign="center">
            If you believe you should have access to this page, please submit a
            ticket here:
          </Box>
          <Box textAlign="center">
            <SpaceBetween direction="horizontal" size="s">
              <Link href={ACCESS_REQUEST_URL} target="_blank">
                Access Request Ticket (US)
              </Link>
              <Link href={ACCESS_REQUEST_URL_CANADA} target="_blank">
                Access Request Ticket (Canada)
              </Link>
            </SpaceBetween>
          </Box>
        </SpaceBetween>
      </ContentLayout>
    </div>
  );
};
export default Error403;
